document.addEventListener("DOMContentLoaded", function () {
    // Initialize sort by dropdown functionality
    initializeSortBy();

    // Select all product review containers and initialize them
    initializeProductReviews();

    // Initialize Add to Cart buttons
    initializeAddToCartButtons();

    // Initialize Load More functionality
    initializeLoadMore();

    function initializeSortBy() {
        // Initialize desktop sort with Choices.js
        const sortBySelect = document.getElementById("SortBy");
        if (sortBySelect) {
            const choices = new Choices(sortBySelect, {
                searchEnabled: false,
                itemSelectText: "",
                shouldSort: false,
                classNames: {
                    containerOuter: ["choices", "choices-fixed-width"],
                },
            });

            // When the sort by selection changes, redirect to the new URL
            sortBySelect.addEventListener("change", function () {
                const url = new URL(window.location.href);
                url.searchParams.set("sort_by", this.value);
                window.location.href = url.toString();
            });
        }

        // Initialize mobile sort drawer
        const mobileSortTrigger = document.querySelector(
            ".cs-plp-products__sort-mobile-trigger"
        );
        const mobileSortDrawer = document.querySelector(
            ".cs-plp-products__mobile-sort-drawer"
        );
        const mobileSortClose = document.querySelector(
            ".cs-plp-products__mobile-sort-close"
        );
        const mobileSortOverlay = document.querySelector(
            ".cs-plp-products__mobile-sort-overlay"
        );
        const mobileSortOptions = document.querySelectorAll(
            ".cs-plp-products__mobile-sort-option"
        );

        if (mobileSortTrigger && mobileSortDrawer) {
            // Open drawer on trigger click
            mobileSortTrigger.addEventListener("click", function () {
                mobileSortDrawer.classList.add("active");
                document.body.style.overflow = "hidden"; // Prevent background scrolling
            });

            // Close drawer functions
            const closeDrawer = function () {
                mobileSortDrawer.classList.remove("active");
                document.body.style.overflow = ""; // Re-enable scrolling
            };

            if (mobileSortClose) {
                mobileSortClose.addEventListener("click", closeDrawer);
            }

            if (mobileSortOverlay) {
                mobileSortOverlay.addEventListener("click", closeDrawer);
            }

            // Add click handlers for mobile sort options
            if (mobileSortOptions) {
                mobileSortOptions.forEach((option) => {
                    option.addEventListener("click", function () {
                        const value = this.getAttribute("data-value");

                        // Update URL and redirect
                        const url = new URL(window.location.href);
                        url.searchParams.set("sort_by", value);
                        window.location.href = url.toString();
                    });
                });
            }

            // Update the sort by label value on mobile
            const updateSortLabel = function () {
                const sortByLabel = document.querySelector(
                    ".cs-plp-products__sort-label-value"
                );
                if (sortByLabel) {
                    const sortBy =
                        new URLSearchParams(window.location.search).get(
                            "sort_by"
                        ) || document.querySelector("#SortBy").value;
                    const selectedOption = document.querySelector(
                        `#SortBy option[value="${sortBy}"]`
                    );
                    if (selectedOption) {
                        sortByLabel.textContent =
                            selectedOption.textContent.trim();
                    }
                }
            };

            // Update label on page load
            updateSortLabel();

            // Update label when sort changes (for when back button is used)
            window.addEventListener("popstate", updateSortLabel);
        }
    }

    function initializeLoadMore() {
        const loadMoreButton = document.querySelector(
            ".cs-plp-products__load-more-button"
        );
        const loadMoreContainer = document.querySelector(
            ".cs-plp-products__load-more-container"
        );
        if (!loadMoreButton || !loadMoreContainer) return;

        loadMoreButton.addEventListener("click", function () {
            const currentPage = parseInt(
                this.getAttribute("data-current-page")
            );
            const totalPages = parseInt(this.getAttribute("data-total-pages"));
            const nextPage = currentPage + 1;

            // Don't proceed if we're at the last page
            if (nextPage > totalPages) {
                loadMoreButton.classList.add("hidden");
                loadMoreContainer.classList.add("hidden");
                return;
            }

            // Show loading state
            loadMoreButton.classList.add("loading");

            // Build the URL for the next page
            let url = window.location.pathname;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set("page", nextPage);
            url = `${url}?${urlParams.toString()}`;

            // Fetch the next page
            fetch(url)
                .then((response) => response.text())
                .then((html) => {
                    // Parse the HTML
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    // Get the product grid from the fetched page
                    const productGrid = doc.querySelector(
                        ".cs-plp-products__grid"
                    );
                    const products = Array.from(
                        productGrid.querySelectorAll(
                            ".cs-plp-product-card__product"
                        )
                    );

                    // Append the products to our grid
                    const ourGrid = document.querySelector(
                        ".cs-plp-products__grid"
                    );
                    products.forEach((product) => {
                        ourGrid.appendChild(product);
                    });

                    // Update the current page on the button
                    loadMoreButton.setAttribute("data-current-page", nextPage);

                    // Hide button if we're at the last page
                    if (nextPage >= totalPages) {
                        loadMoreButton.classList.add("hidden");
                        loadMoreContainer.classList.add("hidden");
                    }

                    // Initialize the newly added products
                    initializeProductReviews();
                    initializeAddToCartButtons();

                    // Remove loading state
                    loadMoreButton.classList.remove("loading");
                })
                .catch((error) => {
                    console.error("Error loading more products:", error);
                    loadMoreButton.classList.remove("loading");
                });
        });
    }

    function initializeProductReviews() {
        const reviewContainers = document.querySelectorAll(
            ".cs-plp-product-card__product-reviews:not([data-initialized])"
        );

        reviewContainers.forEach((container) => {
            // Mark as initialized to prevent duplicate processing
            container.setAttribute("data-initialized", "true");

            const ratingValue = parseFloat(
                container.getAttribute("data-rating") || 0
            );
            const ratingCount = parseInt(
                container.getAttribute("data-rating-count") || 0
            );
            let productColor =
                container.getAttribute("data-product-color") || "#000000";

            // Get the star rating container
            const starContainer = container.querySelector(
                ".cs-plp-product-card__star-rating"
            );
            const countContainer = container.querySelector(
                ".cs-plp-product-card__rating-count"
            );

            if (!starContainer) return;

            // Clear any existing stars (in case of reinitialization)
            starContainer.innerHTML = "";

            // Generate stars
            for (let i = 1; i <= 5; i++) {
                const star = document.createElement("div");
                star.className = "cs-plp-product-card__star";

                // Determine if this should be a full, half, or empty star
                if (ratingValue >= i) {
                    // Full star
                    star.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0L9.163 4.4L14 5.1L10.5 8.5L11.326 13.3L7 11L2.674 13.3L3.5 8.5L0 5.1L4.837 4.4L7 0Z" fill="${productColor}"/>
          </svg>`;
                } else if (ratingValue >= i - 0.5) {
                    // Half star
                    star.className += " cs-plp-product-card__star--half";
                    star.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0L9.163 4.4L14 5.1L10.5 8.5L11.326 13.3L7 11L2.674 13.3L3.5 8.5L0 5.1L4.837 4.4L7 0Z" fill="#D8D8D8"/>
          </svg>
          <div class="star-half">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 0L9.163 4.4L14 5.1L10.5 8.5L11.326 13.3L7 11L2.674 13.3L3.5 8.5L0 5.1L4.837 4.4L7 0Z" fill="${productColor}"/>
            </svg>
          </div>`;
                } else {
                    // Empty star
                    star.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0L9.163 4.4L14 5.1L10.5 8.5L11.326 13.3L7 11L2.674 13.3L3.5 8.5L0 5.1L4.837 4.4L7 0Z" fill="#D8D8D8"/>
          </svg>`;
                }

                starContainer.appendChild(star);
            }

            // Add rating count if available
            if (countContainer && ratingCount > 0) {
                countContainer.textContent = `${ratingCount}`;
                countContainer.style.color = "#000000";
                countContainer.style.opacity = "0.60";
            }
        });

        // Process all products with custom colors
        document
            .querySelectorAll(
                "[data-product-color]:not([data-color-processed])"
            )
            .forEach((product) => {
                // Mark as processed to prevent duplicate processing
                product.setAttribute("data-color-processed", "true");

                const color = product.dataset.productColor;
                if (color) {
                    let processedColor = color;
                    let textColor = "black";

                    // Use starRatingUtils if available
                    if (window.starRatingUtils) {
                        const rgb = window.starRatingUtils.hexToRgb(
                            processedColor.replace("#", "")
                        );
                        const luminance =
                            window.starRatingUtils.calculateLuminance(rgb);
                        textColor = luminance > 0.5 ? "black" : "white";
                    } else {
                        textColor = isColorLight(color) ? "black" : "white";
                    }

                    const style = document.createElement("style");
                    style.textContent = `
          .shopify-product-${product.dataset.productId} .cs-plp-product-card__button:hover {
            background-color: ${processedColor};
            color: ${textColor};
          }
        `;
                    document.head.appendChild(style);
                }
            });
    }

    // Color detection utility function (fallback if starRatingUtils is not available)
    function isColorLight(color) {
        // Remove any leading #
        color = color.replace("#", "");

        // Convert to RGB
        const r = parseInt(color.substr(0, 2), 16);
        const g = parseInt(color.substr(2, 2), 16);
        const b = parseInt(color.substr(4, 2), 16);

        // Calculate relative luminance using sRGB
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        // Return true if color is light (luminance > 0.5)
        return luminance > 0.5;
    }

    function initializeAddToCartButtons() {
        const addToCartButtons = document.querySelectorAll(
            ".add-to-cart-button:not([data-initialized])"
        );

        addToCartButtons.forEach((button) => {
            // Mark as initialized to prevent duplicate event listeners
            button.setAttribute("data-initialized", "true");

            // No need to add event listeners here as they are handled by the global-add-to-cart.js
            // This function is kept to mark buttons as initialized when new products are loaded via Load More
        });
    }

    // Note: These cart functions are now handled by global-add-to-cart.js
    // Keeping these function signatures empty to prevent errors if they are called elsewhere
    function updateCartCount() {
        // Functionality moved to global-add-to-cart.js
        console.info("Cart update handled by global-add-to-cart.js");
    }

    function openCartDrawer() {
        // Functionality moved to global-add-to-cart.js
        console.info("Cart drawer opening handled by global-add-to-cart.js");
    }
});
